import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { StoreFactsData } from 'pages/store-facts/utils/store-facts'
import { IGreenfieldResponse } from 'types/greenfield-response'

interface IStoreLeadershipFetchProps {
    filters: {
        type: string
        pattern: string
        dimension: string
    }[]
}
export const fetchStoreFacts = fetchGeneralData<StoreFactsData>(
    `${ApiSubUrls[Apis.STORE_FACTS]}`,
)

export const fetchStoreLeadership = fetchGeneralData<
    IGreenfieldResponse,
    IStoreLeadershipFetchProps
>(`${ApiSubUrls[Apis.GREENFIELD]}`)
